import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const promotionHistoryApi = {
  getAll: (page = 1, limit = 50, teacherID?: string) => {
    const params = new URLSearchParams()
    params.append('page', page.toString())
    params.append('limit', limit.toString())
    if (teacherID) params.append('teacher_ID', teacherID)
    return api.get<ApiResponse & { pagination: any }>(`/promotion-history?${params.toString()}`)
  },
  export: () => {
    return api.get<Blob>(`/promotion-history/export`, {
      responseType: 'blob'
    })
  }
}

